import { render } from "./content.vue?vue&type=template&id=1f242bb6&scoped=true"
import script from "./content.vue?vue&type=script&lang=js"
export * from "./content.vue?vue&type=script&lang=js"

import "./content.vue?vue&type=style&index=0&id=1f242bb6&lang=css"
import "./content.vue?vue&type=style&index=1&id=1f242bb6&lang=stylus&scoped=true"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f242bb6"]])

export default __exports__